<template>
  <hic-dialog append-to-body title="数据库链接编辑" :visible="visible" @close="cancel" width="50rem" @open="open" :close-on-click-modal="false">
    <el-form v-loading="meta.loading" :model="value" :rules="comRules" ref="submitForm" label-width="7rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编码" prop="code">
            <b v-if="value.id">{{ value.code }}</b>
            <el-input v-else size="small" type="text" placeholder="请输入编码" v-model.trim="value.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="value.name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名" prop="username">
            <el-input size="small" type="text" placeholder="请输入用户名" v-model.trim="value.username" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input size="small" type="text" placeholder="请输入密码" v-model.trim="value.password" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据类型" prop="type">
            <hic-dict-selector dict-type="DbType" placeholder="请选择数据类型" v-model="value.type" is-enum />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-row slot="label">
              <el-button type="warning" @click.prevent="runTest" size="small" :loading="meta.testing" icon="el-icon-s-promotion">测试</el-button>
            </el-row>
            <el-row v-if="resultVal" :class="{ danger: resultVal.indexOf('失败') > -1, success: resultVal.indexOf('成功') > -1 }">{{ resultVal }}</el-row>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="连接字符串" prop="uri">
            <el-input type="textarea" :rows="5" v-model="value.uri" placeholder="请输入连接字符串" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        meta: {
          loading: false,
          testing: false,
        },
        comRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          uri: [{ required: true, message: "请输入连接字符串", trigger: "blur" }],
          type: [{ required: true, message: "请选择类型", trigger: "change" }],
        },
        resultVal: "",
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    },
    methods: {
      open() {
        try {
          this.$set(this, "resultVal", "");
          this.$refs.submitForm.resetFields();
        } catch (error) {}
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.loading = true;
            api.DbCon.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("saved");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
      runTest() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.testing = true;
            api.DbCon.testSql(this.value)
              .then((res) => {
                this.resultVal = "测试成功!";
              })
              .catch((err) => {
                this.resultVal = "测试失败!";
              })
              .finally(() => {
                this.meta.testing = false;
              });
          }
        });
      },
    },
  };
</script>
